import { REDUCER_NAME } from '../constants'

export const getSrc = (state) => state[REDUCER_NAME].src
export const getContentType = (state) => state[REDUCER_NAME].contentType
export const getError = (state) => state[REDUCER_NAME].error
